import { useState } from "react";
import { displayName } from "../../../../engine/selectors";
import type { Player, TournamentState } from "../../../../engine/types";
import type { Tournament } from "../../lib/useTournament";
import { NicknameField, PictureTaker, nameTaken } from "./Join";
import { lengthOf, useSent } from "./sent";

/** The profile sheet: retake the picture, change or clear the nickname, hand the phone to someone else. */
export function Profile({
  t,
  state,
  player,
  onClose,
  onNotMe,
}: {
  t: Tournament;
  state: TournamentState;
  player: Player;
  onClose(): void;
  onNotMe(): void;
}) {
  const [value, setValue] = useState(player.nickname ?? "");
  const [stored, setStored] = useState(false);
  const sent = useSent(t);
  const same = value.trim() === (player.nickname ?? "");
  const giver = player.dub ? state.players[player.dub.by] : undefined;

  return (
    <>
      <div className="profile-top">
        <h1>{player.name}</h1>
        <button type="button" className="btn quiet" onClick={onClose}>
          Close
        </button>
      </div>

      <section className="sticker profile-card">
        <h2>Your picture</h2>
        <PictureTaker t={t} player={player} onStored={() => setStored(true)} />
        {stored && <p className="profile-ok">Saved. It is on the wall now.</p>}
      </section>

      <section className="sticker profile-card">
        <h2>Your nickname</h2>
        {player.dub && (
          <p>
            Renamed {player.dub.nickname} by {giver ? displayName(giver, "phone") : "a winner"} until round{" "}
            {player.dub.untilRound}. Your own comes back after that.
          </p>
        )}
        <NicknameField state={state} me={player.id} value={value} onChange={setValue} label="On the wall" />
        {sent.refused && (
          <p className="player-refused" role="alert">
            Not saved: {sent.refused}
          </p>
        )}
        {sent.landed && same && <p className="profile-ok">Saved.</p>}
        <div className="join-actions">
          <button
            type="button"
            className="btn quiet"
            disabled={!player.nickname || sent.waiting}
            onClick={() => {
              setValue("");
              sent.send({ type: "player.profile", id: player.id, nickname: null });
            }}
          >
            Clear
          </button>
          <button
            type="button"
            className="btn accent"
            disabled={!lengthOf(value) || same || sent.waiting || nameTaken(state, value, player.id)}
            onClick={() => sent.send({ type: "player.profile", id: player.id, nickname: value })}
          >
            {sent.waiting ? "Saving" : "Save"}
          </button>
        </div>
      </section>

      <section className="sticker profile-card">
        <h2>Not {player.name}?</h2>
        <p>Pick a different name on this phone. Nothing of theirs is lost.</p>
        <button type="button" className="btn warn" onClick={onNotMe}>
          Not you?
        </button>
      </section>
    </>
  );
}
